import { FC, useCallback, useContext, useMemo } from "react";

import { useCampaignDefaults } from "../../../hooks/useCampaignDefaults";
import { handleAIReset } from "./helpers/handleAIReset";
import { Button } from "../../../../ui/layout/molecules/Button";
import { Disabled } from "../../../../components/Disabled";
import { UpdateCampaignProps } from "../../types";
import { SlideOverCloseContext } from "../../../../ui/layout/organisms/SlideOver/SlideOverWrapper/SlideOverWrapper";

export const ResetCampaign: FC<UpdateCampaignProps> = ({
  campaign,
  updateCampaignBody,
}) => {
  const { defaultPresetValues } = useCampaignDefaults(campaign.type);
  const { updatedNets, updatedSimilarity } = useMemo(
    () => handleAIReset(campaign, defaultPresetValues),
    [campaign, defaultPresetValues],
  );
  const { onClose } = useContext(SlideOverCloseContext);

  const handleReset = useCallback(async () => {
    const success = await updateCampaignBody(
      {
        ...updatedNets,
        ...updatedSimilarity,
      },
      undefined,
    );
    if (success) {
      onClose();
    }
    return success;
  }, [updatedNets, updatedSimilarity, updateCampaignBody, onClose]);

  const allowReset = useMemo(
    () => !!Object.keys(updatedNets).length,
    [updatedNets],
  );

  return (
    <div className="flex flex-row flex-wrap justify-between gap-2 my-4">
      <Disabled editPermissions="campaign:advanced_config:update">
        <Button
          disabled={!allowReset}
          title="Set default AI methods"
          buttonType="danger"
          onClick={handleReset}
          className="resetButton w-full"
          tooltip={allowReset ? undefined : "Site AI methods do not match"}
        />
      </Disabled>
    </div>
  );
};
